module.exports = __webpack_public_path__ + "img/bannerbackground.2a6ebc14.png";